<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :destroyOnClose="true"
    :cancelText="language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">

        <a-form-model-item :label="language['parentNode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="pid">
          <j-category-select-prevent ref="treeSelect" v-model="model.pid" :currid="currid" ></j-category-select-prevent>
        </a-form-model-item>

        <a-form-model-item :label="language['categoryName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
          <a-input v-model="model.name" :placeholder="language['common.pleaseInput']+language['categoryName']"></a-input>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction,getAction } from '@/api/manage'
  import JCategorySelectPrevent from './JCategorySelectPrevent'
  
  import { validateDuplicateValue } from '@/utils/util' 

  export default {
    name: "ProvinceListModal",
    components: {
      JCategorySelectPrevent
    },
    data () {
      return {
        title:"操作",
        width:800,
        visible: false,
        model: {},
        currid:'',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        validatorRules:{
          pid:{},
          name: [{ required: true, message: '请输入名称' },
                {max: 200, message: '长度不能超过200', trigger: 'blur'},
          ]
        },
        url: {
          list: "/prevent/category/categoryList",
          add: "/prevent/category/add",
          edit: "/prevent/category/edit",
          checkCode:"/prevent/category/checkCode",
        },
        expandedRowKeys:[],
        pidField:"pid",
        subExpandedKeys:[],
        pCategoryOptions:[],

      }
    },
    created () {      
      this.loadData(1)
    },
    computed : {
      disabled() {
          return this.model.id?true : false;
      },
      language() {
        return this.$store.getters.language
      }
    },
     methods: {
        loadData(arg){
          this.loading = true
          let params = {pageNo:1,pageSize:100000};
          return new Promise((resolve) => {
            getAction(this.url.list,params).then(res=>{
              if(res.success){
                let result = res.result
                if(Number(result.total)>0){                
                  this.pCategoryOptions = this.getDataByResult(res.result.records)
                }
              }else{
                this.$message.warning(res.message)
              }
            }).finally(()=>{
              this.loading = false
            })
          })
        },
        add () {
          this.edit({});
        },
        edit (record) {
          this.model = Object.assign({}, record);
          this.currid = this.model.id;
          this.visible = true;
        },
        close () {
          this.$emit('close');
          this.visible = false;
          this.$refs.form.resetFields();
        },
        handleOk () {
          const that = this;
          // 触发表单验证
          this.$refs.form.validate(valid => {
            if (valid) {
              that.confirmLoading = true;
              let httpurl = '';
              let method = '';
              if(!this.model.id){
                httpurl+=this.url.add;
                method = 'post';
              }else{
                httpurl+=this.url.edit;
                 method = 'put';
              }
              httpAction(httpurl,this.model,method).then((res)=>{
                if(res.success){
                  that.$message.success(res.message);
                  // close的时候清空了表单的值 导致model为空 修改值在列表页没有变 此处需要复制一下model
                  that.submitSuccess({...this.model})
                }else{
                  that.$message.warning(res.message);
                }
              }).finally(() => {
                that.confirmLoading = false;
                that.close();
              })
            }else{
              return false;
            }
      
          })
        },
        handleCancel () {
          this.close()
        },
        submitSuccess(formData){
          if(!formData.id){
            let treeData = this.$refs.treeSelect.getCurrTreeData()
            this.expandedRowKeys=[]
            this.getExpandKeysByPid(formData[this.pidField],treeData,treeData)
            if(formData.pid && this.expandedRowKeys.length==0){
              this.expandedRowKeys = this.subExpandedKeys;
            }
            this.$emit('ok',formData,this.expandedRowKeys.reverse());
          }else{
            this.$emit('ok',formData);
        }
        },
        getExpandKeysByPid(pid,arr,all){
          if(pid && arr && arr.length>0){
            for(let i=0;i<arr.length;i++){
              if(arr[i].key==pid){
                this.expandedRowKeys.push(arr[i].key)
                this.getExpandKeysByPid(arr[i]['parentId'],all,all)
              }else{
                this.getExpandKeysByPid(pid,arr[i].children,all)
              }
            }
          }
        },
      
      }
  }
</script>